import { gql } from '@apollo/client'

import { ORDER_STATUS } from 'features/Inventories/components/OrderStatus/constants'

export const isPending = (order: TSFixMe): TSFixMe => {
  return order.status === ORDER_STATUS.PENDING
}

export const GET_PENDING_ORDERS_COUNT = gql`
  query GetPendingOrdersCount($limit: Int!, $page: Int!, $inventoryId: ID, $status: OrderStatus) {
    orders(pagination: { size: $limit, page: $page }, input: { inventoryID: $inventoryId, status: $status }) {
      total
    }
  }
`

export const resolvers = {
  Mutation: {
    shipOrder(_root: TSFixMe, { orderId }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Order',
          id: orderId
        }),
        fragment: gql`
          fragment OrderStatus on Order {
            status
          }
        `,
        data: {
          status: ORDER_STATUS.PENDING,
          __typename: 'Order'
        }
      })

      return null
    },
    cancelOrder(_root: TSFixMe, { orderId }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Order',
          id: orderId
        }),
        fragment: gql`
          fragment OrderStatus on Order {
            status
          }
        `,
        data: {
          status: ORDER_STATUS.CANCELLED,
          __typename: 'Order'
        }
      })

      return null
    },
    rejectOrder(_root: TSFixMe, { orderId }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Order',
          id: orderId
        }),
        fragment: gql`
          fragment OrderStatus on Order {
            status
          }
        `,
        data: {
          status: ORDER_STATUS.REJECTED,
          __typename: 'Order'
        }
      })

      return null
    },
    increasePendingOrdersCount(_root: TSFixMe, { inventoryId }: TSFixMe, { cache }: TSFixMe) {
      const { orders } = cache.readQuery({
        query: GET_PENDING_ORDERS_COUNT,
        variables: {
          limit: 100000,
          page: 1,
          inventoryId,
          status: ORDER_STATUS.PENDING
        }
      })
      cache.writeQuery({
        query: GET_PENDING_ORDERS_COUNT,
        variables: {
          limit: 100000,
          page: 1,
          inventoryId,
          status: ORDER_STATUS.PENDING
        },
        data: {
          orders: {
            ...orders,
            total: orders.total + 1
          }
        }
      })

      return null
    },
    decreasePendingOrdersCount(_root: TSFixMe, { inventoryId }: TSFixMe, { cache }: TSFixMe) {
      const { orders } = cache.readQuery({
        query: GET_PENDING_ORDERS_COUNT,
        variables: {
          limit: 100000,
          page: 1,
          inventoryId,
          status: ORDER_STATUS.PENDING
        }
      })
      cache.writeQuery({
        query: GET_PENDING_ORDERS_COUNT,
        variables: {
          limit: 100000,
          page: 1,
          inventoryId,
          status: ORDER_STATUS.PENDING
        },
        data: {
          orders: {
            ...orders,
            total: orders.total - 1
          }
        }
      })

      return null
    }
  }
}
